<template>
    <div class="animated fadeIn rolePage bgV2">
        <b-row>
            <b-col md="12">
                <gofix-tab
                        class="mt-3"
                        :data="tabData">
                    <template slot="gofixTab:right">
                        <gofix-button class="mr-3" label="Export" @click="exportData"></gofix-button>
                        <gofix-form-dropdown
                                class="highlightDropdown mr-3"
                                label=""
                                :clearable="false"
                                :searchable="false"
                                placeholder="Filter by company"
                                :options="roleTypes"
                                :reduce="option => option.value"
                                v-model="roleTypeSelector"
                        >
                        </gofix-form-dropdown>
                        <gofix-button label="Save" :disabled="!$checkRole($accessModule.roles, 'update')" @click="saveData"></gofix-button>
                    </template>
                    <template slot="gofixTab:all_contract">
                        <role-permission :scope="1" :roleTypeSelector="roleTypeSelector" ref="roleItem"></role-permission>
                    </template>
                    <template slot="gofixTab:contract">
                        <role-permission :scope="3" :roleTypeSelector="roleTypeSelector" ref="roleItem"></role-permission>
                    </template>
                </gofix-tab>
            </b-col>
        </b-row>
    </div>
</template>
<script>
    import RoleItem from "./item"
    export default {
        name: 'Role',
        data() {
            return {
                tabData:[
                    {
                        key: "all_contract",
                        title: "ALL Contracts",
                        active: true
                    },
                    {
                        key: "contract",
                        title: "Contract",
                        active: false
                    },
                ],
                roleTypeSelector:"FM",
                scope:1,
                roleTypes:[
                    {label: 'FM OFFICER', value: 'FM'},
                    {label: 'CLIENT STAFF', value: 'Client'},
                    {label: 'SUPPLIER', value: 'Supplier'},
                    {label: 'TENANT', value: 'Tenant'}
                ],
            }
        },
        components: {
            "role-permission": RoleItem
        },
        created() {},
        methods: {
            saveData(){
                this.$refs.roleItem.savePermissions();
                // if(this.scope === 1){
                //     this.$refs.roleItem.savePermissions();
                // }else{
                //     this.$refs.contractRole.savePermissions();
                // }
            },
            exportData(){
                this.$store.dispatch( 'RoleController/exportData', {})
                .then(response => {
                    console.log(response.data);
                    const url = window.URL.createObjectURL(new Blob([response.data]),{
                        type: 'application/vnd.ms-excel'
                    });
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'role-and-authorisation.xlsx'); //or any other extension
                    document.body.appendChild(link);
                    link.click();
                })
            }
        }
    }
</script>
